import { OrderItemCreationDto, OrderItemUpdateDto } from '../dtos/order-item.dto';
import { OrderItem, OrderItemCreation, OrderItemUpdate } from '../models/order-item';
import { dateMapper } from './date.mapper';

/**
 * Map to order item from order item dto.
 * @param {object} dto Dto data.
 * @returns {OrderItem}
 */
function fromDto(dto) {
  return new OrderItem({
    id: dto.id,
    packageId: dto.package_id,
    packageName: dto.package_name,
    packageDescription: dto.package_description,
    isFreeFoodHandlerCard: dto.is_free_food_handler_card ?? false,
    price: dto.price,
    quantity: dto.qty,
    isPaid: dto.is_paid,
    paymentDate: dateMapper.fromDto(dto.payment_date),
    expirationDate: dateMapper.fromDto(dto.expiration_date),
    discountCode: dto.discount_code,
    discountCodeAmount: dto.discount_code_amount,
    discountCustomAmount: dto.discount_custom_amount,
    orderId: dto.order_id,
  });
}

/**
 * Map quantity update data to dto.
 * @param {OrderItemUpdate} data Quantity data.
 * @returns {OrderItemUpdateDto}
 */
function toUpdateDto(data) {
  return new OrderItemUpdateDto({
    package_id: data.packageId,
    qty: data.quantity,
    discount_custom_amount: data.discountCustomAmount,
    discount_code: data.discountCode,
  });
}

/**
 * Map order item to creation dto.
 * @param {OrderItemCreation} data Order creation data.
 * @returns {OrderItemCreationDto}
 */
function toCreationDto(data) {
  return new OrderItemCreationDto({
    package_id: data.packageId,
    qty: data.quantity,
    discount_custom_amount: data.discountCustomAmount,
    discount_code: data.discountCode,
    remember_class_id: data.rememberClassId ?? undefined,
    remember_exam_language_id: data.rememberExamLanguageId ?? undefined,
  });
}

export const orderItemMapper = {
  fromDto,
  toUpdateDto,
  toCreationDto,
};
